<template>
  <a-modal
    :visible="visible"
    :title="id ? $t('modal.editTitle') : $t('modal.createTitle')"
    :destroy-on-close="true"
    :mask-closable="false"
    :closable="false"
    :width="'40%'"
    @cancel="handleCancel()"
  >
    <template slot="footer">
      <a-button key="cancel" @click="handleCancel">
        {{ $t('modal.cancel') }}
      </a-button>
      <a-button key="submit" type="primary" :disabled="loading" :loading="loading" @click="handleSubmit">
        {{ id ? $t('modal.update') : $t('modal.create') }}
      </a-button>
    </template>
    <a-spin :spinning="loading">
      <div class="spin-content setting-modal">
        <a-form :form="form" @submit="handleSubmit">
          <a-row>
            <a-col :md="24">
              <a-form-item :label="$t('groupManager.column.name')">
                <a-input
                  v-decorator="[
                    'name',
                    {
                      initialValue: data ? data.name : '',
                      rules: [{ required: true, message: $t('groupManager.validations.nameRequired') }]
                    }
                  ]"
                  maxlength="255"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :md="24">
              <a-form-item :label="$t('groupManager.column.description')">
                <a-textarea
                  v-decorator="[
                    'description',
                    {
                      initialValue: data ? data.description: ''
                    }
                  ]"
                  :rows="5"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import {
  StoreGroup as ApiStoreGroup,
  ShowGroup as ApiShowGroup,
  UpdateGroup as ApiUpdateGroup
} from '@/api/groups';

export default {
  name: 'GroupModal',
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      id: null,
      data: null,
      loading: false
    };
  },
  methods: {
    getGroup() {
      this.loading = true;
      ApiShowGroup({ id: this.id })
        .then((response) => {
          this.data = response.data;
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },
    showModal(id = null) {
      this.visible = true;
      this.id = id;
      this.clearData();
      if (id) {
        this.getGroup();
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields({ force: true }, (err, values) => {
        if (!err) {
          const apiName = this.id ? ApiUpdateGroup : ApiStoreGroup;
          if (this.id) {
            values.id = this.id;
          }
          this.loading = true;
          apiName(values)
            .then(() => {
              this.loading = false;
              this.visible = false;
              this.$notification.success({ message: this.$t(`modal.successMessage.${this.id ? 'updateSuccess' : 'createSuccess'}`) });
              this.$emit('updateGroupSuccess');
            })
            .catch((error) => {
              const { message } = error.response.data;
              // Show error message
              this.$error({
                title: this.$t('modal.failModal.title'),
                content: message,
                okText: this.$t('modal.failModal.close')
              });
              this.loading = false;
            });
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    clearData() {
      this.form.resetFields();
    }
  }
};
</script>

<style lang="scss">
    .setting-modal {
        .ant-form-item {
            margin: 0 0 15px !important;
        }
        .ant-form-item-label {
            line-height: 25px !important;
        }
    }
</style>
